import { ItemsViewLayoutSwitch } from '@app/components/items-view-layout-switch/ItemsViewLayoutSwitch';
import { useFragmentsSettingsStore } from '@app/modules/fragments/stores/fragments-settings.store';
import { useFragmentGridViewToggleTour } from './useFragmentGridViewToggleTour';

const groupSx = {
  height: 36,
  '& .MuiToggleButton-root': { px: 1.5, border: '1px solid #e0e0e0' },
} as const;

/**
 * Toolbar control: button group for view mode (list / gridWide / gridNormal / gridCompact).
 * Persists in fragments settings store. Shows a one-time tour on first visit.
 * Closes the tour when the user clicks any toggle button.
 */
export function FragmentGridViewToggle() {
  const { closeTour } = useFragmentGridViewToggleTour();

  const viewMode = useFragmentsSettingsStore((state) => state.viewMode);
  const setViewMode = useFragmentsSettingsStore((state) => state.setViewMode);

  const handleChange = (newViewMode: Parameters<typeof setViewMode>[0]) => {
    closeTour();
    setViewMode(newViewMode);
  };

  return (
    <ItemsViewLayoutSwitch
      value={viewMode}
      onChange={handleChange}
      sx={groupSx}
      id="fragment-grid-view-toggle"
    />
  );
}
